import * as React from 'react'
import { AppSidebar } from '@/components/app-sidebar'
import { GuidedTour } from '@/components/guided-tour'
import { SiteHeader } from '@/components/site-header'
import {
  SidebarInset,
  SidebarProvider,
} from '@/components/ui/sidebar'
import { cn } from '@/lib/utils'

interface GeneralLayoutPageProps {
  children: React.ReactNode
  className?: string
}

export function GeneralLayoutPage({ children, className }: GeneralLayoutPageProps) {
  return (
    <SidebarProvider
      style={
        {
          '--sidebar-width': 'calc(var(--spacing) * 72)',
          '--header-height': 'calc(var(--spacing) * 12)',
        } as React.CSSProperties
      }
    >
      <AppSidebar variant="inset" side="right" />
      <SidebarInset>
        <SiteHeader />
        <div className={cn('flex flex-1 flex-col overflow-auto', className)}>
          {children}
        </div>
      </SidebarInset>
      <GuidedTour />
    </SidebarProvider>
  )
}
